<div class="face-matching-container">
  <div class="face-matching-title">Detected Faces</div>

  <div class="face-list" *ngIf="faces.length > 0">
    <div *ngFor="let face of faces; trackBy: trackByFaceId" class="face-item-container">
      <div *ngIf="face.mediaId && showMediaPreview" class="face-media-preview">
        <img [src]="face.mediaPreview | pixsellPreviewUrl" alt="Source photo" />
      </div>
      <app-face-item
        [faceId]="face.id"
        [thumbnail]="buildUrl(face.thumbnail)"
        [personValue]="face.person"
        [disabled]="disabled"
        (personChange)="onPersonChange($event)"
      ></app-face-item>
    </div>
  </div>

  <div class="no-faces" *ngIf="faces.length === 0">
    <ng-container>No faces detected in these images.</ng-container>
  </div>
</div>
